export default __webpack_public_path__ + "c2093b72253657f40aab80080688d5c8.png";